import React, { useState, useEffect } from "react";
import { Badge, Button, Col, Container, Form, Modal, Table, Row } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { API } from "../../config/api";
import LoaderHome from "../Loader/LoaderHome";
import swal from "sweetalert";
import WellcomeCard from "../Admin/Components/Wellcome";
import HeaderOdontogram from "./Components/HeaderOdontogram.js";
import { useMediaQuery } from "react-responsive";
import Select from 'react-select';
import { FaSync } from "react-icons/fa";
import AsyncSelect from 'react-select/async';
import DataTable from "react-data-table-component";
import DentalTable from "./Data/Odontogram.js";


export default function Login() {
    document.title = "SDC Apps";
    const navigate = useNavigate()
    const { id_patient, id_appointment } = useParams();

    // refactor
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(false);
    const [getData, setGetData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    console.log(getData, "getData")

    const handleRowClick = (row) => {
        setSelectedRow(row);
        setShowModal(true);
    };

    const columns = [
        {
            name: "Nama Pasien",
            selector: row => row.full_name,
            sortable: true,
        },
        {
            name: "Anamnesa",
            selector: row => row.anamnesa,
            sortable: true,
        },
        {
            name: "Kode Appointment",
            selector: row => row.code,
            sortable: true,
        },
        {
            name: "Aksi",
            cell: row => (
                <Button size="sm" variant="primary" onClick={() => handleRowClick(row)}>
                    Lihat data
                </Button>
            ),
        },
    ];


    // const filteredData = getData.filter(item =>
    //     item.full_name?.toLowerCase().includes(search.toLowerCase())
    // );

    const [getDataShowPatient, setGetDataShowPatient] = useState(null);
    const [getDataTreatmentPlanByPatient, setGetDataTreatementPlanByPatient] = useState([]);
    const [getDataShowTreatmentPlanByAppointmentPatient, setGetDataShowTreatementPlanByAppointmentPatient] = useState(null);
    const [getDataDentalMainAppointment, setGetDataDentalMainAppointment] = useState(null);
    const [anamnesaOptions, setAnamnesaOptions] = useState([]);
    const [getAnamnesas, setGetAnamnesas] = useState([]);
    const [toothString, setToothString] = useState([]);
    const [toothConditionsMap, setToothConditionsMap] = useState({});
    const [toothRestorationsMap, setToothRestorationsMap] = useState({});
    const [toothRestorationMaterialsMap, setToothRestorationMaterialsMap] = useState({});
    const [toothProtesaMap, setToothProtesaMap] = useState({});
    const [toothProtesaMaterialMap, setToothProtesaMaterialMap] = useState({});
    const [toothOcclusiMap, setToothOcclusiMap] = useState([]);
    const [toothTorusPalatinus, setToothTorusPalatinus] = useState("");
    const [toothTorusMandibularis, setToothMandibularis] = useState("");
    const [toothPalatum, setToothPalatum] = useState("");
    const [toothDiastema, setToothDiastema] = useState("");
    const [toothAnomali, setToothAnomali] = useState("");
    const [toothOtherDentalOralConditions, setToothOtherDentalOralConditions] = useState("");
    const [toothNumberOfDecayedTeeth, setToothNumberOfDecayedTeeth] = useState("");
    const [toothNumberOfMissingTeeth, setToothNumberOfMissingTeeth] = useState("");
    const [toothNumberOfTeethFilled, setToothNumberOfTeethFilled] = useState("");

    const [highlightedTeeth, setHighlightedTeeth] = useState([]);
    const [hoveredTooth, setHoveredTooth] = useState(null);
    const [lastToothWithCondition, setLastToothWithCondition] = useState(null);
    const [lastToothWithRestoration, setLastToothWithRestoration] = useState(null);
    const [lastToothWithRestorationMaterial, setLastToothWithRestorationMaterial] = useState(null);
    const [lastToothWithProtesa, setLastToothWithProtesa] = useState(null);
    const [lastToothWithProtesaMaterial, setLastToothWithProtesaMaterial] = useState(null);

    const [dataItem, setGetDataItem] = useState({ id_doctor: "", id_treatment: "", id_room: "", tooth_number: "", qty: "1", choiceGigi: "satu_gigi", treatment_price_min: "", treatment_price_max: "", estimate_price: "", id_description: "", description: "", code_description: "", assistants: ["", ""] })
    const [getDataProfileDetail, setGetDataProfileDetail] = useState([]);
    const [selectedTreatmentPlan1, setSelectedTreatmentPlan] = useState(null);
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 980px)' })
    const [query, setQuery] = useState("");
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [pages, setPages] = useState();
    const [ascending, setAscending] = useState(0);
    const [rows, setRows] = useState(1);
    const [keyword, setKeyword] = useState("");
    const [msg, setMsg] = useState("");

    const [selected, setSelected] = useState(null);
    const [selectedShowPatient, setSelectedShowPatient] = useState(null);
    const [getAllToothNumbers, setAllToothNumbers] = useState(null);
    const [infoGigi, setInfoGigi] = useState("XX-X")

    // Kondisi 
    const [kondisiGigi, setKondisiGigi] = useState('');
    const [toothConditions, setToothConditions] = useState({});

    const token = localStorage.getItem("token");

    let fetchParams = {
        headers: { "Authorization": `${token}`, "Content-Type": "application/json" }
    };

    const cache = {};


    const loadPatients = async (inputValue, callback) => {
        if (inputValue.length < 2) return callback([]);

        if (cache[inputValue]) return callback(cache[inputValue]);

        try {
            const response = await API.get(
                `transaction-service/patients/representative/index?page=0&limit=10&ascending=0&search=${inputValue}`,
                fetchParams
            );

            const options = response?.data?.data?.map(item => ({
                value: item.id,
                label: `${item.first_name} ${item.last_name}`,
            })) || [];

            cache[inputValue] = options;
            callback(options);
        } catch (error) {
            callback([]);
        }
    };


    const GetResponseDataShowPatient = async () => {
        try {
            setLoading(true)
            const response = await API.get(`transaction-service/patients/${id_patient}`, fetchParams)
            // Checking process
            if (response?.status === 200) {
                setGetDataShowPatient(response?.data?.data)
                setSelectedShowPatient({
                    value: response.data.data.id,
                    label: `${response.data.data.first_name} ${response.data.data.last_name}`
                });
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
            swal({
                title: 'Failed',
                text: `${error.response.data.message}`,
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    }

    const GetDentalMainConditions = async () => {
        try {
            setLoading(true);

            const conditions = await API.get(
                `emr-service/dental-mains/conditions/${id_patient}?page=${page}&limit=all&ascending=${ascending}&id_appointment=${id_appointment}`,
                fetchParams
            );

            const restorations = await API.get(
                `emr-service/dental-mains/restorations/${id_patient}?page=${page}&limit=all&ascending=${ascending}&id_appointment=${id_appointment}`,
                fetchParams
            );

            const restorationMaterials = await API.get(
                `emr-service/dental-mains/restoration-materials/${id_patient}?page=${page}&limit=all&ascending=${ascending}&id_appointment=${id_appointment}`,
                fetchParams
            );

            const protesas = await API.get(
                `emr-service/dental-mains/protesas/${id_patient}?page=${page}&limit=all&ascending=${ascending}&id_appointment=${id_appointment}`,
                fetchParams
            );

            const protesaMaterials = await API.get(
                `emr-service/dental-mains/protesa-materials/${id_patient}?page=${page}&limit=all&ascending=${ascending}&id_appointment=${id_appointment}`,
                fetchParams
            );

            const newToothConditionsMap = {};
            const newToothRestorationsMap = {};
            const newToothRestorationMaterialMap = {};
            const newToothProtesaMap = {};
            const newToothProtesaMaterialMap = {};

            conditions.data.data.forEach(item => {
                const tooth = item.tooth_number?.trim();
                const name = item.dental_condition;

                if (!tooth || !name) {
                    return;
                }

                if (!newToothConditionsMap[tooth]) {
                    newToothConditionsMap[tooth] = [];
                }

                if (!newToothConditionsMap[tooth].includes(name)) {
                    newToothConditionsMap[tooth].push(name);
                }
            });

            restorations.data.data.forEach(item => {
                const tooth = item.tooth_number?.trim();
                const name = item.dental_restoration;

                if (!tooth || !name) {
                    return;
                }

                if (!newToothRestorationsMap[tooth]) {
                    newToothRestorationsMap[tooth] = [];
                }

                if (!newToothRestorationsMap[tooth].includes(name)) {
                    newToothRestorationsMap[tooth].push(name);
                }
            });

            restorationMaterials.data.data.forEach(item => {
                const tooth = item.tooth_number?.trim();
                const name = item.dental_restoration_material;
                if (!tooth || !name) return;

                if (!newToothRestorationMaterialMap[tooth]) {
                    newToothRestorationMaterialMap[tooth] = [];
                }

                if (!newToothRestorationMaterialMap[tooth].includes(name)) {
                    newToothRestorationMaterialMap[tooth].push(name);
                }
            });

            protesas.data.data.forEach(item => {
                const tooth = item.tooth_number?.trim();
                const name = item.dental_protesa;
                if (!tooth || !name) return;

                if (!newToothProtesaMap[tooth]) {
                    newToothProtesaMap[tooth] = [];
                }

                if (!newToothProtesaMap[tooth].includes(name)) {
                    newToothProtesaMap[tooth].push(name);
                }
            });

            protesaMaterials.data.data.forEach(item => {
                const tooth = item.tooth_number?.trim();
                const name = item.dental_protesa_material;
                if (!tooth || !name) return;

                if (!newToothProtesaMaterialMap[tooth]) {
                    newToothProtesaMaterialMap[tooth] = [];
                }

                if (!newToothProtesaMaterialMap[tooth].includes(name)) {
                    newToothProtesaMaterialMap[tooth].push(name);
                }
            });


            if (conditions?.status === 200) {
                setToothConditionsMap(newToothConditionsMap);
                setLoading(false);
            }

            if (restorations?.status === 200) {
                setToothRestorationsMap(newToothRestorationsMap);
                setLoading(false);
            }

            if (restorationMaterials?.status === 200) {
                setToothRestorationMaterialsMap(newToothRestorationMaterialMap);
                setLoading(false);
            }

            if (protesas?.status === 200) {
                setToothProtesaMap(newToothProtesaMap);
                setLoading(false);
            }

            if (protesaMaterials?.status === 200) {
                setToothProtesaMaterialMap(newToothProtesaMaterialMap);
                setLoading(false);
            }




        } catch (error) {
            setLoading(false);
            swal({
                title: 'Failed',
                text: error?.response?.data?.message || 'Unknown error',
                icon: 'error',
                timer: 3000,
                buttons: false,
            });
        }
    };

    const GetResponseDataDentalMain = async () => {
        try {
            setLoading(true);

            let url = `emr-service/dental-mains/${id_patient}?page=${page}&limit=${limit}&ascending=${ascending}`;

            if (id_appointment) {
                url += `&id_appointment=${id_appointment}`;
            }

            if (keyword) {
                url += `&search=${keyword}`;
            }


            const response = await API.get(url, fetchParams);
            const dataArray = response.data?.data ?? [];

            // Build anamnesa options
            const anamnesaOptions = dataArray
                .map(item => ({
                    label: item.treatment_plan?.anamnesa,
                    value: item.treatment_plan?.id_appointment,
                    id_patient: item.id_patient,
                    id_appointment: item.treatment_plan?.id_appointment,
                }))
                .filter(item => item.label && item.id_appointment);

            setGetAnamnesas(anamnesaOptions);

            if (id_appointment && anamnesaOptions.length > 0) {
                const selected = anamnesaOptions.find(item => item.id_appointment === id_appointment);
                if (selected) {
                    setSelectedTreatmentPlan(selected);
                }
            }

            // Build tooth string
            const allToothNumbers = dataArray
                .flatMap(item =>
                    item.treatment_details?.flatMap(detail =>
                        detail.tooth_number?.split(/\s+/) ?? []
                    ) ?? []
                )
                .filter(Boolean);


            const joinedToothString = allToothNumbers.join(" ");
            setToothString(joinedToothString);

            // Save raw data
            setGetDataShowTreatementPlanByAppointmentPatient(dataArray);

            if (response?.data?.pagination) {
                setPage(response.data.pagination.current_page);
                setPages(response.data.pagination.total_pages);
                setRows(response.data.pagination.total);
            }

            setLoading(false);
        } catch (error) {
            setLoading(false);
            swal({
                title: 'Failed',
                // text: '3',
                text: `${error?.response?.data?.message}`,
                icon: 'error',
                timer: 3000,
                buttons: false
            });
        }
    };

    const handleChangePatient = (selectedOption) => {
        if (selectedOption) {
            setSelected(null);
            setSelectedTreatmentPlan(null);
            setSelectedShowPatient(null);
            navigate(`/odontograms/${selectedOption.value}`);
        }
    };


    const handleChangeTreatementPlan = (selectedOption) => {
        if (selectedOption && selectedOption.id_appointment) {
            setSelectedTreatmentPlan(selectedOption);
            navigate(`/odontograms/${selectedOption.id_patient}/${selectedOption.id_appointment}`);
        } else {
            setSelectedTreatmentPlan(null);
            navigate(`/odontograms/${id_patient}`);
        }
    };


    useEffect(() => {
        if (id_appointment && getAnamnesas.length > 0) {
            const selected = getAnamnesas.find(item => item.id_appointment === id_appointment);
            if (selected) {
                setSelectedTreatmentPlan(selected);
            }
        }
    }, [id_appointment, getAnamnesas]);


    useEffect(() => {
        if (id_patient !== undefined && id_appointment === undefined) {
            GetResponseDataShowPatient();
            GetResponseDataDentalMain();
        }
        if (id_patient !== undefined && id_appointment !== undefined) {
            GetDentalMainConditions();
        }

    }, [id_patient, id_appointment, page, ascending, keyword]);

    const buttonRefresh = () => {
        window.location.reload();
    };

    const searchData = (e) => {
        e.preventDefault();
        setPage(0);
        setMsg("");
        setKeyword(query);
    };

    useEffect(() => {
        if (
            id_patient &&
            id_appointment &&
            Array.isArray(getDataShowTreatmentPlanByAppointmentPatient) &&
            getDataShowTreatmentPlanByAppointmentPatient.length > 0
        ) {
            const matched = getDataShowTreatmentPlanByAppointmentPatient.find(item =>
                item.id_appointment === id_appointment
            );

            if (matched) {
                setSelectedTreatmentPlan({
                    label: matched.treatment_plan?.anamnesa,
                    value: matched.id_appointment,
                    id_patient: matched.id_patient,
                    id_appointment: matched.id_appointment
                });
            }
        }
    }, [id_appointment, getDataShowTreatmentPlanByAppointmentPatient]);

    const selectedTreatmentPlan = selectedTreatmentPlan1;

    useEffect(() => {
        if (Array.isArray(getAnamnesas) && getAnamnesas.length > 0) {
            const options = getAnamnesas.map((item) => ({
                label: `${item.label}`,
                value: item.value,
                id_appointment: item.id_appointment,
                id_patient: item.id_patient,
            }));
            setAnamnesaOptions(options);
        }
    }, [getAnamnesas]);



    useEffect(() => {
        const fetchOcclusis = async () => {
            try {
                const occlusis = await API.get(`emr-service/dental-mains/occlusis/${id_patient}/${id_appointment}?page=${page}&limit=${limit}&ascending=${ascending}&id_appointment=${id_appointment}`,
                    fetchParams
                );

                const combinedDisplay = occlusis.data.data[0].dental_occlusi
                    .map(item => item.display)
                    .filter(display => !!display)
                    .join(', ');

                if (occlusis.data?.data?.length > 0) {
                    setToothOcclusiMap(combinedDisplay);
                } else {
                    setToothOcclusiMap(null);
                }
            } catch (error) {
                console.error('Gagal mengambil data oklusi:', error);
            }
        };

        const fetchAnatomis = async () => {
            try {
                const anatomis = await API.get(`emr-service/dental-mains/anatomis/${id_patient}?page=${page}&limit=${limit}&ascending=${ascending}&id_appointment=${id_appointment}`,
                    fetchParams
                );

                if (anatomis.data?.data?.length > 0) {
                    const row = anatomis.data.data[0];

                    const torusPalatinusCombined = Array.isArray(row.torus_palatinus)
                        ? row.torus_palatinus
                            .map(item => item.description)
                            .filter(Boolean)
                            .join(', ')
                        : row.torus_palatinus || null;

                    const torusMandibularisCombined = Array.isArray(row.torus_mandibularis)
                        ? row.torus_mandibularis
                            .map(item => item.description)
                            .filter(Boolean)
                            .join(', ')
                        : row.torus_mandibularis || null;

                    const palatumCombined = Array.isArray(row.palatum)
                        ? row.palatum
                            .map(item => item.description)
                            .filter(Boolean)
                            .join(', ')
                        : row.palatum || null;

                    const diastemaCombined = Array.isArray(row.diastema)
                        ? row.diastema
                            .map(item => item.description)
                            .filter(Boolean)
                            .join(', ')
                        : row.diastema || null;

                    const anomaliCombined = Array.isArray(row.anomali)
                        ? row.anomali
                            .map(item => item.description)
                            .filter(Boolean)
                            .join(', ')
                        : row.anomali || null;

                    const otherDentalOralConditionCombined = Array.isArray(row.other_dental_oral_conditions)
                        ? row.other_dental_oral_conditions
                            .map(item => item.description)
                            .filter(Boolean)
                            .join(', ')
                        : row.other_dental_oral_conditions || null;

                    const toothNumberOfDecayedTeethCombined = Array.isArray(row.number_of_decayed_teeth)
                        ? row.number_of_decayed_teeth
                            .map(item => item.description)
                            .filter(Boolean)
                            .join(', ')
                        : row.number_of_decayed_teeth || null;

                    const toothNumberOfMissingTeethCombined = Array.isArray(row.number_of_missing_teeth)
                        ? row.number_of_missing_teeth
                            .map(item => item.description)
                            .filter(Boolean)
                            .join(', ')
                        : row.number_of_missing_teeth || null;

                    const toothNumberOfFilledTeethCombined = Array.isArray(row.number_of_filled_teeth)
                        ? row.number_of_filled_teeth
                            .map(item => item.description)
                            .filter(Boolean)
                            .join(', ')
                        : row.number_of_filled_teeth || null;

                    setToothTorusPalatinus(torusPalatinusCombined);
                    setToothMandibularis(torusMandibularisCombined);
                    setToothPalatum(palatumCombined);
                    setToothDiastema(diastemaCombined);
                    setToothAnomali(anomaliCombined);
                    setToothOtherDentalOralConditions(otherDentalOralConditionCombined);
                    setToothNumberOfDecayedTeeth(toothNumberOfDecayedTeethCombined);
                    setToothNumberOfMissingTeeth(toothNumberOfMissingTeethCombined);
                    setToothNumberOfTeethFilled(toothNumberOfFilledTeethCombined);
                } else {
                    setToothTorusPalatinus(null)
                    setToothMandibularis(null);
                    setToothPalatum(null);
                    setToothDiastema(null);
                    setToothAnomali(null);
                    setToothOtherDentalOralConditions(null);
                    setToothNumberOfDecayedTeeth(null);
                    setToothNumberOfMissingTeeth(null);
                    setToothNumberOfTeethFilled(null);
                }
            } catch (error) {
                console.error('Gagal mengambil data anatomis:', error);
            }
        };

        if (id_patient !== undefined && id_appointment !== undefined) {
            fetchOcclusis();
            fetchAnatomis()
        }
    }, [id_patient, id_appointment, page, limit, ascending, id_appointment]);

    return (
        <>
            <Row>
                <WellcomeCard
                    getDataProfileNull={getDataProfileDetail === null}
                    getDataProfileFirstName={getDataProfileDetail?.firstname}
                    getDataProfileLastName={getDataProfileDetail?.lastname}
                />
            </Row>
            <div style={{ backgroundColor: "white", marginTop: "15px", marginLeft: "10px", marginRight: "10px", boxShadow: "2px 2px 10px #BFBFBF" }}>
                {loading && <LoaderHome />}
                <HeaderOdontogram
                    isTabletOrMobile={isTabletOrMobile}
                    query={query}
                    setQuery={setQuery}
                    limit={limit}
                    setLimit={setLimit}
                    buttonRefresh={buttonRefresh}
                    searchData={searchData}
                    {...(id_patient && { showCustomButtonBack: true })}
                />

                <Container>
                    <Row>
                        <Col md={3}>

                        </Col>
                        <Col md={12}>
                            <DentalTable />

                            {/* Modal Detail */}
                            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                                <Modal.Header closeButton>
                                    <Modal.Title>Detail Pemeriksaan Gigi</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                    {selectedRow && (
                                        <Table bordered striped>
                                            <tbody>
                                                <tr>
                                                    <td>Nama Pasien</td>
                                                    <td>{selectedRow.full_name}</td>
                                                </tr>
                                                <tr>
                                                    <td>Jumlah Gigi Berlubang</td>
                                                    <td>{selectedRow.number_of_decayed_teeth}</td>
                                                </tr>
                                                <tr>
                                                    <td>Jumlah Gigi Hilang</td>
                                                    <td>{selectedRow.number_of_missing_teeth}</td>
                                                </tr>
                                                <tr>
                                                    <td>Jumlah Gigi Ditambal</td>
                                                    <td>{selectedRow.number_of_teeth_filled}</td>
                                                </tr>
                                                <tr>
                                                    <td>Torus Palatinus</td>
                                                    <td>{selectedRow.torus_palatinuses?.[0]?.description || "-"}</td>
                                                </tr>
                                                <tr>
                                                    <td>Torus Mandibularis</td>
                                                    <td>{selectedRow.torus_mandibularises?.[0]?.description || "-"}</td>
                                                </tr>
                                                <tr>
                                                    <td>Palatum</td>
                                                    <td>{selectedRow.palata?.[0]?.description || "-"}</td>
                                                </tr>
                                                <tr>
                                                    <td>Diastema</td>
                                                    <td>{selectedRow.diastemas?.[0]?.description || "-"}</td>
                                                </tr>
                                                <tr>
                                                    <td>Anomali</td>
                                                    <td>{selectedRow.anomalis?.[0]?.description || "-"}</td>
                                                </tr>
                                                <tr>
                                                    <td>Occlusi</td>
                                                    <td>{selectedRow.occlusis?.map(o => o.description).join(", ") || "-"}</td>
                                                </tr>
                                                <tr>
                                                    <td>Kondisi Gigi</td>
                                                    <td>
                                                        {selectedRow.conditions?.length > 0 ? (
                                                            <ol style={{ paddingLeft: "20px", margin: 0 }}>
                                                                {selectedRow.conditions.map((c, i) => {
                                                                    const desc = c.condition?.description || "-";
                                                                    return <li key={i}>{desc}</li>;
                                                                })}
                                                            </ol>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Restorasi Gigi</td>
                                                    <td>
                                                        {selectedRow.restorations?.length > 0 ? (
                                                            <ol style={{ paddingLeft: "20px", margin: 0 }}>
                                                                {selectedRow.restorations.map((c, i) => {
                                                                    const desc = c.restoration?.description || "-";
                                                                    return <li key={i}>{desc}</li>;
                                                                })}
                                                            </ol>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Bahan Restorasi Gigi</td>
                                                    <td>
                                                        {selectedRow.restorationMaterials?.length > 0 ? (
                                                            <ol style={{ paddingLeft: "20px", margin: 0 }}>
                                                                {selectedRow.restorationMaterials.map((c, i) => {
                                                                    const desc = c.restorationMaterial?.description || "-";
                                                                    return <li key={i}>{desc}</li>;
                                                                })}
                                                            </ol>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Protesa Gigi</td>
                                                    <td>
                                                        {selectedRow.protesas?.length > 0 ? (
                                                            <ol style={{ paddingLeft: "20px", margin: 0 }}>
                                                                {selectedRow.protesas.map((c, i) => {
                                                                    const desc = c.protesa?.description || "-";
                                                                    return <li key={i}>{desc}</li>;
                                                                })}
                                                            </ol>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Bahan Protesa Gigi</td>
                                                    <td>
                                                        {selectedRow.protesaMaterials?.length > 0 ? (
                                                            <ol style={{ paddingLeft: "20px", margin: 0 }}>
                                                                {selectedRow.protesaMaterials.map((c, i) => {
                                                                    const desc = c.protesaMaterial?.description || "-";
                                                                    return <li key={i}>{desc}</li>;
                                                                })}
                                                            </ol>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    )}
                                </Modal.Body>
                            </Modal>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
}
